import Cookies from 'js-cookie'
import config  from '@/config/index'
import business from '@/utils/business'

function getTokenKey() {
  return config.token
}

function getVisitorTokenValue() {
  return config.visitorToken
}

function getAppIdValue() {
  return config.appId
}

function getExhibitionIdValue() {
  return config.exhibitionId
}

export function getToken() {
  return Cookies.get(getTokenKey())
}

export function setToken(token) {
  return Cookies.set(getTokenKey(), token)
}

export function removeToken() {
  return Cookies.remove(getTokenKey())
}

export function getVisitorToken() {
  return getVisitorTokenValue()
}

export function getExhibitionId() {
  return getExhibitionIdValue()
}

export function getAppId() {
  return getAppIdValue()
}

//白名单
export function getWhiteList() {
  return config.router.whiteList
}

//黑名单 (展商|客商)
export function noEnterRouter(subjectType, route) {
  let roles = route.meta ? route.meta.roles || null : null
  if (roles === null) return false
  if (roles instanceof Array) {
    return !roles.includes(subjectType)
  } else if (typeof roles === 'object') {
    roles = roles[route.params.type]
    return !roles.includes(subjectType)
  }
}

// 工作台的所有路由地址
export function wordRouteList() {
  // '/profile', 
  return config.router.workRouterList
}

/**
 * 客商 工作台 权限
 * 客商 注册没有预登记的话 不能进入工作台
 * subjectType 身份
 * route 路由
 */
export function workBenchList(subjectType, info, route) {
  // const list = wordRouteList()
  // const status = info && info.exhibitionUserCompleteState ? info.exhibitionUserCompleteState.completeExhibitionRegistration : true
  // const auditState   = info.visitor ? info.visitor.auditState : false
  // const languageType = info.visitor ? info.visitor.languageType : false
  // if (status) {

  //   if (subjectType == 'VISITOR' && auditState == 'DISAPPROVE' && languageType == 'cn' && list.indexOf(route.path) > -1) {
  //     return 1
  //   } else if (subjectType == 'VISITOR' && auditState == 'PENDING' && languageType == 'cn' && list.indexOf(route.path) > -1) {
  //     return 2
  //   }

  //   return true
  // } else if (subjectType == 'VISITOR' && !status && list.indexOf(route.path) > -1) {
  //   return false
  // } else {
  //   return true
  // }

  if (subjectType === 'VISITOR') {
    const list = wordRouteList()
    if (list.includes(route.path)) {
      const name = info.visitor ? info.visitor.name : info.userInfo ? info.userInfo.name : ''
      return !!name
    }
  }
  return true
}

// 客商 登录/注册后，访问注册流程的判断
export function visitorRegisterAuthority(subjectType, info, to) {
    if (subjectType !== 'VISITOR') return true
    let pathName = to.name
    let registerNames = [
        'registerEmail',
        'registerMobile',
        'registerPassWord',
        'registerCompleted',
        'lAccountInfoEmail',
        'lAccountInfoMobile',
        'account-info',
        'questionnaire']
    if (!registerNames.includes(pathName)) return true
    let status = business.isCompleteExhibitionRegistration()
    if (status) {
        registerNames = ['registerCompleted']
        if (!registerNames.includes(pathName)) return false
        return true
    } else {
        let state = info.exhibitionUserCompleteState
        if (!state || (state && !state.completeVisitor)) {
            // 第一步完善信息
            registerNames = ['lAccountInfoEmail', 'lAccountInfoMobile']
            if (!registerNames.includes(pathName)) return false
        } else if (!state.completeVisitorRegister) {
            // 第二步完善信息
            registerNames = ['account-info']
            if (!registerNames.includes(pathName)) return false
        } else {
            // 问卷
            registerNames = ['questionnaire']
            if (!registerNames.includes(pathName)) return false
        }
    }
    return true
}

// 注册设置密码，强制设置身份 路由
export function getRegSetIdentityList() {
  return config.router.setIdentityList
}

/**
 * 判断路由是否匹配
 * @param {Array} list  路由名单（存在正则）
 * @param {string} path 路由地址
 */
export const isPathMatched = function (list, path) {
  let matchList = list.filter(item => {
    if (typeof item == 'string') {
      return item == path
    } else {
      return item.test(path)
    }
  })
  return matchList.length == 0 ? false : true
}